function u(n, o, i, a, d, t, f, l) {
  var e = typeof n == "function" ? n.options : n;
  return o && (e.render = o, e.staticRenderFns = i, e._compiled = !0), t && (e._scopeId = "data-v-" + t), {
    exports: n,
    options: e
  };
}
export {
  u as default
};
